// src/redux/sagas/categoriesSaga.ts
import { call, put, takeLatest, select } from 'redux-saga/effects';
// import { PayloadAction } from '@reduxjs/toolkit';
import {
  fetchCategoriesRequest,
  fetchCategoriesSuccess,
  fetchCategoriesFailure,
  Category,
} from '../slices/categoriesSlice';
// import { RootState } from '../store';
import ENDPOINTS from '../../api/endpoints';
import { request } from '../../api/request';

function* fetchCategoriesSaga(): Generator<any, void, any> {
  try {
    // console.log('🔥 Categories saga triggered!');
    
    // Get restaurant ID from Redux
    // const selectedRestaurant = yield select((state: RootState) => state.restaurant.selectedRestaurant);
    
    // console.log('🏪 Selected restaurant:', selectedRestaurant);
    
    // if (!selectedRestaurant?.id) {
    //   console.error('❌ No restaurant selected');
    //   throw new Error('No restaurant selected');
    // }

    const apiUrl = `${ENDPOINTS.API_V2_BASE_URL}${ENDPOINTS.CATEGORIES_API_PATH}`;
    // console.log('📡 Fetching categories from:', apiUrl);
    // console.log('🔑 Restaurant ID:', selectedRestaurant.id);

    // Fetch categories from API
    const response = yield call(request, {
      url: apiUrl,
      method: 'GET',
      headers: {
        'restaurant-id': '7cdb36d9-c51b-473e-9a9f-cfc468ee6d0b',
      },
      requiresRestaurantId:false
    });

    console.log('📥 Categories API response:', response);

    if (response.success && response.data) {
      yield put(fetchCategoriesSuccess(response.data as Category[]));
    } else {
      yield put(fetchCategoriesFailure(response.message || 'Failed to fetch categories'));
    }
  } catch (error: any) {
    console.error('❌ Categories fetch error:', error);
    yield put(fetchCategoriesFailure(error.message || 'Failed to fetch categories'));
  }
}

export function* categoriesSaga() {
  yield takeLatest(fetchCategoriesRequest.type, fetchCategoriesSaga);
}
